
import { Button } from 'react-bootstrap';
import './ClaimOffer.css';

const ClaimOffer = (props) => {


  return (
    <div className="claimContainer">

      <h2 className='claimH2'>Ready to claim your offer?</h2>
      <Button onClick={() => {
        console.log("PROPS: ", props.refProp.current)
        // props.refProp.current.scrollIntoView({})
      }} className='btnClaim'>CLAIM YOUR OFFER</Button>

    </div >
  )
}

export default ClaimOffer;
